"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWifiEnabledDeviceDetails = exports.getRelayDevice = exports.getWifiEnabledDevice = void 0;
const Utils_1 = require("../../../Utils");
const IndexApiProfileRequestTypes_1 = require("../../Types/IndexApiProfileRequestTypes");
const IndexProfile_1 = require("../../Types/IndexProfile");
const getWifiEnabledDevice = (thing, devices) => {
    if (typeof thing === "undefined") {
        return { connected: false };
    }
    const device = devices.find((d) => d.id === thing.deviceId);
    if (device === undefined) {
        return { connected: false };
    }
    const isRelay = device.roles.some((r) => r.type === IndexApiProfileRequestTypes_1.DeviceRoleType.RELAY);
    return {
        type: thing.type,
        deviceId: thing.deviceId,
        connected: thing.connected,
        serialNumber: thing.model.serialNumber,
        firmwareVersion: thing.lastCheckin.firmwareRevision === IndexProfile_1.UNKNOWN
            ? thing.model.firmwareRevision : thing.lastCheckin.firmwareRevision,
        ssid: thing.lastCheckin.ssid,
        relay: isRelay,
        modelId: thing.model.model,
        lastCheckinTime: thing.lastCheckin.time,
    };
};
exports.getWifiEnabledDevice = getWifiEnabledDevice;
const getRelayDevice = (things, devices) => {
    const relayDevices = things.map((t) => (0, exports.getWifiEnabledDevice)(t, devices)).filter((w) => w.relay);
    const hasEdison = things.some((t) => t.type === IndexApiProfileRequestTypes_1.IndexAPIThingType.V1);
    if (relayDevices.length > 1) {
        Utils_1.Log.warn(`[WifiDetails] Should not have more than one relay! Number of relays: ${relayDevices.length}`);
        return relayDevices[0];
    }
    if (relayDevices.length === 1) {
        return relayDevices[0];
    }
    if (hasEdison) {
        const copiedV1Things = things.filter((t) => t.type === IndexApiProfileRequestTypes_1.IndexAPIThingType.V1);
        return (0, exports.getWifiEnabledDevice)(copiedV1Things.reduce((prevThing, thing) => {
            if (typeof prevThing === "undefined") {
                return undefined;
            }
            return thing.lastCheckin.time > prevThing.lastCheckin.time ? thing : prevThing;
        }, copiedV1Things.pop()), devices);
    }
    return {
        connected: false,
    };
};
exports.getRelayDevice = getRelayDevice;
const getWifiEnabledDeviceDetails = (profile) => {
    const things = Object.values(profile.things);
    const allDevices = Object.values(profile.devices);
    const device = (0, exports.getRelayDevice)(things, allDevices);
    const wifiDevices = things.map((thing) => (0, exports.getWifiEnabledDevice)(thing, allDevices));
    const details = {
        relayDevice: device,
        devices: wifiDevices,
    };
    Utils_1.Log.info(`[WifiDetails] WiFi enabled device details: ${JSON.stringify(details)}`);
    return details;
};
exports.getWifiEnabledDeviceDetails = getWifiEnabledDeviceDetails;
//# sourceMappingURL=WifiDetails.js.map